// Convert text newlines to HTML: double newlines → paragraphs, single → <br>
function textToHtmlParagraphs(text) {
  if (!text) return '';
  return text
    .replace(/\r\n/g, '\n')
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map(
      (paragraph) =>
        `<p style="line-height: 1.4;">${paragraph.replace(/\n/g, '<br>')}</p>`
    )
    .join('');
}

export function normalizePricePosition(payload = {}) {
  return {
    position: payload.position ?? null,
    label: payload.label ?? null,
    label_translated: payload.label_translated ?? null,
  };
}

export default textToHtmlParagraphs;
